import { Badge } from '@/components/ui/badge';
import { useTranslation } from 'react-i18next';
import type { PlayerStatus } from '@swiss-magic/shared-types';

const CLASS_BY_STATUS: Record<PlayerStatus, string> = {
  accepted: 'bg-green-600 text-xs',
  rejected: 'bg-red-600 text-xs',
  blocked: 'bg-red-800 text-xs',
  none: 'text-xs text-muted-foreground',
  withdrawn: 'text-xs',
  eliminated: 'text-xs text-orange-700',
  // Story 100 — spot-secured registration flow.
  spot_secured: 'bg-sky-600 text-xs',
  waitlisted: 'text-xs text-amber-700',
};

export function PlayerStatusBadge({ status }: { status: PlayerStatus }) {
  const { t } = useTranslation('director');
  const className = CLASS_BY_STATUS[status];
  const label = t(`players_page.status.${status}`);

  if (status === 'spot_secured') {
    return (
      <Badge variant="default" className={className}>
        {label}
      </Badge>
    );
  }
  if (status === 'waitlisted') {
    return (
      <Badge variant="secondary" className={className}>
        {label}
      </Badge>
    );
  }
  if (status === 'accepted') {
    return (
      <Badge variant="default" className={className}>
        {label}
      </Badge>
    );
  }
  if (status === 'rejected' || status === 'blocked') {
    return (
      <Badge variant="destructive" className={className}>
        {label}
      </Badge>
    );
  }
  if (status === 'withdrawn' || status === 'eliminated') {
    return (
      <Badge variant="secondary" className={className}>
        {label}
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className={className}>
      {label}
    </Badge>
  );
}
